import React, { useState } from "react";
import * as Coversheet from "./Coversheet";
import { FileService } from "../../../services/SubmissionService";
import { Endpoints } from "../../../helpers/Endpoints";

export default function NewCaseInformationPanel({
    coversheet,
    onComplete,
    attorneyId,
}: Coversheet.CoversheetProps) {
    const [hasDataFile, setHasDataFile] = useState(
        undefined as boolean | undefined
    );

    const [filename, setFilename] = useState("");

    const onClickHasDataFile = () => setHasDataFile(true);
    const onClickNoDataFile = () => setHasDataFile(false);

    const onFileUpload = (event: React.FormEvent) => {
        event.preventDefault();
        const input = event.target as HTMLInputElement;

        if (!input.files?.length) {
            return;
        }

        for (let i = 0; i < input.files.length; i++) {
            const f = input.files[i];

            FileService.upload({
                fileServiceUrl: Endpoints.FileManager,
                file: f,
                filename: "uploads/" + f.name,
            }).then(
                (resp) => {
                    setFilename(f.name);
                },
                (error) => {
                    //input.value = "";
                }
            );
        }
    };

    const onSubmit = (event: React.FormEvent) => {
        event.preventDefault();

        onComplete({
            ...coversheet,
            hasDataFile: true,
            dataFileName: filename,
        });
    };

    return (
        <>
            <div>
                <h4 className="header-title">Case Information</h4>

                <p className="sub-header">
                    Do you have a CSV or data file with your case information?
                </p>
            </div>
            <div className="row  mb-2">
                <div className="col-12">
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={onClickHasDataFile}
                    >
                        Yes
                    </button>
                    &nbsp;
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={onClickNoDataFile}
                    >
                        No
                    </button>
                </div>
            </div>
            {hasDataFile === true && (
                <>
                    <div className="row mb-2">
                        <h4 className="header-title">Data File Upload</h4>
                        <p>
                            Please attach an approved data file. If we have not
                            previously reviewed your data file or your data file
                            has changed in anyway since the last review please{" "}
                            <b>STOP</b> and contact{" "}
                            <a href="mailto:support@efilemadeeasy.com?subject=Forgot%20Password">
                                support
                            </a>{" "}
                            to review.
                        </p>
                        <p>
                            <b>
                                Uploading an unsupported or unapproved data file
                                may result in your case being filed incorrectly
                                at the expense of the filing attorney.
                            </b>
                        </p>
                    </div>
                    <form
                        action="#"
                        className="needs-validation"
                        onSubmit={onSubmit}
                    >
                        {" "}
                        <div className="row">
                            <div className="mb-2 row">
                                <label
                                    className="col-md-1 col-form-label"
                                    htmlFor="example-fileinput"
                                >
                                    Data File
                                </label>
                                <div className="col-md-6">
                                    <input
                                        type="file"
                                        className="form-control"
                                        id="example-fileinput"
                                        onChange={onFileUpload}
                                        required={true}
                                    />
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div
                                    className="col-12"
                                    style={{ textAlign: "center" }}
                                >
                                    <button
                                        className="btn btn-success"
                                        type="submit"
                                        style={{
                                            right: 24,
                                            bottom: 40,
                                            position: "absolute",
                                        }}
                                    >
                                        Next
                                        <i className="mdi mdi-arrow-right"></i>
                                    </button>

                                    <div style={{ color: "red" }}>{}</div>
                                </div>
                            </div>
                        </div>
                    </form>
                </>
            )}
            {hasDataFile === false && (
                <>
                    <div className="row">
                        <h4 className="header-title">New Case Coversheet</h4>
                        <p className="sub-header">
                            Fill the form below in order for your case to be
                            properly filed.
                        </p>
                    </div>
                    <div className="row">
                        {" "}
                        <Coversheet.default
                            onComplete={onComplete}
                            coversheet={coversheet}
                            attorneyId={attorneyId}
                        />
                    </div>
                </>
            )}
        </>
    );
}
